import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["from", "enter", "leave", "config"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useTransition, a } from '@isyc-react/animation/lib';
import clsx from 'clsx';
import { Modal } from '@isyc-react/design/bootstrap';
import '@isyc-react/design/main';
import "./full-container-relative.modal.style.scss";
const dA = {
  from: {
    opacity: 0
  },
  enter: {
    opacity: 1
  },
  leave: {
    opacity: 0
  },
  config: {
    mass: 5,
    tension: 2000,
    friction: 200
  }
};
export let ModalArchiveSizeValues = /*#__PURE__*/function (ModalArchiveSizeValues) {
  ModalArchiveSizeValues["FULL"] = "full";
  ModalArchiveSizeValues["SMALL"] = "sm";
  ModalArchiveSizeValues["LARGE"] = "lg";
  ModalArchiveSizeValues["XLARGE"] = "xl";
  return ModalArchiveSizeValues;
}({});
export const FullContainerRelativeModal = props => {
  const {
    show,
    className,
    children,
    transformOrigin = '50% 50%',
    size,
    animation = dA
  } = props;
  const {
      from = dA.from,
      enter = dA.enter,
      leave = dA.leave,
      config = dA.config
    } = animation,
    rest = _objectWithoutProperties(animation, _excluded);
  const ref = React.useRef(null);
  const transitions = useTransition(show, _objectSpread({
    from,
    enter,
    leave,
    config
  }, rest));
  React.useEffect(() => {
    if (show) {
      document.body.classList.add('dialog-modal-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('dialog-modal-open');
      document.body.style.overflow = '';
    }
  }, [show]);
  React.useEffect(() => {
    return () => {
      document.body.classList.remove('dialog-modal-open');
      document.body.style.overflow = '';
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, size === ModalArchiveSizeValues.FULL ? /*#__PURE__*/React.createElement(React.Fragment, null, transitions((styles, item) => /*#__PURE__*/React.createElement(React.Fragment, null, item && /*#__PURE__*/React.createElement(a.div, {
    className: clsx('full-container-modal-relative', className),
    style: _objectSpread(_objectSpread({}, styles), {}, {
      transformOrigin: typeof transformOrigin === 'string' ? transformOrigin : transformOrigin()
    }),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, typeof children === 'function' ? children(typeof transformOrigin === 'string' ? transformOrigin : transformOrigin()) : children))))) : /*#__PURE__*/React.createElement(Modal, {
    show: show,
    ref: ref,
    size: size
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, typeof children === 'function' ? children(typeof transformOrigin === 'string' ? transformOrigin : transformOrigin()) : children)));
};
FullContainerRelativeModal.defaultProps = {
  size: ModalArchiveSizeValues.FULL
};